import {
  MenuButton as ChakraMenuButton,
  MenuButtonProps as ChakraMenuButtonProps,
  forwardRef,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

type MenuButtonProps = SwashbuckleComponentProps<ChakraMenuButtonProps>

export const MenuButton = forwardRef<MenuButtonProps, 'button'>(
  (props, ref) => {
    const { 'data-qa': dataQa, className, ...chakraMenuButtonProps } = props

    return (
      <ChakraMenuButton
        ref={ref}
        data-qa={dataQa}
        className={className}
        {...chakraMenuButtonProps}
      />
    )
  }
)

MenuButton.displayName = 'MenuButton'
